import { authAxios } from '../lib/axios';
import type { CmsLoginResponse } from '../types/auth.types';

export const authService = {
  /**
   * Step 1: KGID + PIN against admin-managed users (rrms_users). Returns
   * requires_otp: true with a short-lived OTP token; then call verifyOtp.
   */
  login: async (kgid: string, pin: string) => {
    const response = await authAxios.post<CmsLoginResponse>('/auth/login', {
      kgid,
      password: pin,
    });
    return response.data;
  },

  /** Step 2: verify the OTP using the temp token from step 1 (hardcoded 12345 for now). */
  verifyOtp: async (otp: string, tempToken: string) => {
    const response = await authAxios.post<CmsLoginResponse>(
      '/auth/verify-otp',
      { otp },
      { headers: { token: tempToken } }
    );
    return response.data;
  },
};

export default authService;
